import styled, { css, DefaultTheme } from 'styled-components';

export const getProjectSingleSectionStyling = (theme: DefaultTheme) => css`
  background: ${theme.colors.white_1};
  border: 1px solid ${theme.colors.grey_1};
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
`;

export const ProjectSingleContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
